import * as React from "react";
import { Box, Link } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function SkuLabelWrap({label, url, maxWidth=120}) {

    const styles = {
        whiteSpace: "normal",
        wordWrap: "break-word",
        maxWidth: `${maxWidth}px`,
        display: "inline-block",
        verticalAlign: "middle"
    }

    return <Box sx={styles}>
        <Link href={url} target="_blank" sx={{ cursor: "pointer", color: 'text.primary', '&:hover':{ textDecoration: 'none'} }}>
            {label}
        </Link>
        <IconSeeker icon="up-right-from-square" sx={{ mr: 0.5, margin: .5, color: 'primary.main' }}/> 
    </Box>
}